import { useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";
import { toast } from "sonner";
import { api, imageUrl, formatApiError } from "@/lib/api";

export const ImageUpload = ({ value, onChange }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.path);
      toast.success("Image uploaded");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
      ref.current.value = "";
    }
  };

  return (
    <div data-testid="admin-lead-image-field">
      {value ? (
        <div className="relative">
          <img src={imageUrl(value)} alt="" className="w-full aspect-[16/9] object-cover border border-[var(--rule)]" data-testid="admin-lead-image-preview" />
          <button type="button" onClick={() => onChange("")} className="absolute top-2 right-2 bg-white/95 p-1.5 hover:text-[var(--accent)]" data-testid="admin-lead-image-remove-button">
            <X size={16} />
          </button>
        </div>
      ) : (
        <button type="button" onClick={() => ref.current.click()} disabled={busy} className="w-full aspect-[16/9] border border-dashed border-[#BDBDBA] flex flex-col items-center justify-center gap-2 font-ui text-sm text-[var(--ink-2)] hover:border-[var(--ink)] hover:text-[var(--ink)] transition-colors" data-testid="admin-lead-image-upload-button">
          <ImagePlus size={20} strokeWidth={1.5} />
          {busy ? "Uploading…" : "Upload lead image (optional)"}
        </button>
      )}
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid="admin-lead-image-input" />
    </div>
  );
};
